import { NavigationBar } from "./navigationBar/NavigationBar";
import styled from "styled-components";
import ErrorAlert from "../shared/components/ErrorAlert";
import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setError } from "../store/slices/ErrorSlice";
import { SidebarMenu } from "./sidebarMenu/SidebarMenu";
import { TabBar } from "./tabs/TabBar";

const ComponentWrapper = styled.div`
  margin-left: var(--sidebar-width, 220px);
  max-width: calc(100% - var(--sidebar-width, 220px));
  width: 100%;
  margin-top: 40px; /* Space for TabBar */
  transition: margin-left 0.2s ease-in-out, max-width 0.2s ease-in-out;
`;

const ContentWrapper = styled.div`
  margin-top: 53px; 
  display: flex;
`;

export const PageLayout = (props) => {
  const error = useSelector((state) => state.error.message);
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (error) setOpen(true);
  }, [error]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    dispatch(setError(""));
  };

  // Detect if SplashPage is being rendered
  const isSplashPage = window.location.pathname === "/home";

  return (
    <div>
      <NavigationBar />
      <TabBar />
      <ContentWrapper>
        {/* Hide SidebarMenu on SplashPage */}
        {!isSplashPage && <SidebarMenu/>}
        <ComponentWrapper style={isSplashPage ? { marginLeft: 0, maxWidth: '100%' } : {}}>
          {props.children}
        </ComponentWrapper>
      </ContentWrapper>
      <ErrorAlert handleClose={handleClose} open={open} errorMessage={error} />
    </div>
  );
};
